<template>
  <v-content class="pt-0">
    <v-layout row wrap align-center justify-center>
      <v-card max-width="1900" class="text-center">
        <v-card max-width="1000" class="ma-10" flat>
          <v-card-title class="justify-center">
            <h2>Freedom Hair peruker</h2>
          </v-card-title>
          <v-card-text>
            Vi vet vad de flesta med håravfall önskar av en peruk, men också att våra behov och önskemål kan se
            olika ut. Därför är alla Freedom peruker skräddarsydda efter kunden och vid beställningen kan ett
            flertal önskemål specificeras.
          </v-card-text>
        </v-card>
        <v-card max-width="1000" class="ma-10" flat>
          <v-card-title class="justify-center">Säkerhet</v-card-title>
          <v-card-text>
            Som många kan vittna om kan traditionella peruker vara opålitliga. Även om elastiska hättor, med
            resår eller kardborreband fungerar utmärkt på ett huvud med hår, så glider de gärna av en skalp
            utan. Freedom Hair perukerna är svåra att lossa och släpper inte av misstag. Genom att säkerställa
            en perfekt passform skapas en sugeffekt som står emot vardagslivets påfrestningar – till och med
            den starkaste vind!
          </v-card-text>
        </v-card>
        <v-card max-width="1000" class="ma-10" flat>
          <v-card-title class="justify-center">Komfort</v-card-title>
          <v-card-text>
            Materialet i hättorna samt vassa hårändar i vanliga elastiska peruker, irriterar ofta känsliga
            hårbottnar, särskilt personer med alopeci. Freedom Hair peruker är lena, lätta och känns som en
            andra hud. Hårändarna är inkapslade i den mjuka silikonhättan och kommer inte i kontakt med din
            hårbotten. Du kommer att känna frisörens fingrar i din hårbotten under klippningen och frisören
            kommer bara att känna hår och skalp – inga tjocka kanter! Hättorna håller alltid formen och kryper
            alltså inte upp i nacken.
          </v-card-text>
        </v-card>
        <v-card max-width="1000" class="ma-10" flat>
          <v-card-title class="justify-center">Utseende</v-card-title>
          <v-card-text>
            De flesta elastiska modeperuker ser helt enkelt inte ut eller beter sig som äkta hår. Detta beror på
            att syntetiska fibrer ofta blir missfärgade i solen eller krusar sig av värmen när du till exempel öppnar
            en ugnslucka. Peruker med näthätta kan dela sig som en persienn och blotta partier av hårfri skalp
            mellan rader av resår. En del peruker av äkta hår på marknaden saknar spänsten hos levande hår.
            Det här beror på att de är tillverkade av kraftigt behandlat asiatiskt eller indiskt hår, där ytskikt och
            färg tagits bort och håret återfärgats för den europeiska marknaden. Freedom Hair peruker tillverkas
            av europeiskt hår av bästa kvalité – hår som inte blekts, färgats eller behandlats på något sätt.
            Naturligtvis kan din peruk tillverkas av passande asiatiskt eller indiskt hår om du är av asiatiskt eller
            indiskt ursprung. När du beställer din Freedom Hair protes får du gärna specificera vilken typ av hår
            du vill ha. Vi skräddarsyr peruken efter dina behov. Ett utmärkt sätt att förmedla dina önskemål till
            oss är via bilder, kanske ett foto av dig från förr eller en helt ny frisyr som du upptäckt.
          </v-card-text>
        </v-card>
        <v-card max-width="1000" class="ma-10" flat>
          <v-card-title class="justify-center">Tillverkningsprocess</v-card-title>
          <v-card-text>
            Vi börjar med att skanna ditt huvud med en 3D-scanner för att få en exakt passform. Den skannade
            bilden mejlas sedan direkt till tillverkaren på Nya Zeeland där en silikonbotten tillverkas i din hudton
            och där sedan håret planteras in hårstrå för hårstrå. Alla hårstrån som planteras in är lika långa,
            vilket gör att det i den färdiga peruken ser ut som att håret är uppklippt i nacken. Den färdiga
            peruken är helt oklippt när den levereras så att du, tillsammans med din frisör, kan komma fram till
            en frisyr som passar just dig. Det är bra om du redan vid beställningen har med dig bilder på hur du
            vill att slutresultatet ska se ut, så hjälps vi åt att sätta ihop rätt längd, lockighet, färg, volym och
            hårriktning, för att slutresultatet ska bli så bra som möjligt.
          </v-card-text>
        </v-card>
        <v-card max-width="1000" class="ma-10" flat>
          <v-card-title class="justify-center">Skötselråd</v-card-title>
          <v-card-text>
            Med tiden kommer normalt slitage på grund av dagligt bruk uppstå på din peruk – precis som om du
            skulle använt samma kläder under hela dagen, varje dag. Om du vid upprepade tillfällen sover i
            peruken kommer detta att orsaka onödigt slitage. Att gnugga huvudet mot nackstödet i bilen eller
            att vid upprepade tillfällen tvinna samma hårslinga likaså. Du bör absolut undvika att använda
            peruken under hjälm då trycket från hjälmen ofta orsakar stor skada på peruken.
            Det är viktigt att du tvättar av både ditt huvud och insidan av silikonhättan varje dag. Detta
            bibehåller silikonhättans vidhäftande egenskaper och förhindrar otrevlig lukt. Använd en liten
            mängd (som en femkrona) diskmedel och skölj ur ordentligt. Att endast skölja ur med vatten eller att
            använda tvål eller schampo är inte tillräckligt för att hålla porerna i hättan öppna. Fett från huden
            eller återfettande medel i tvål och schampo täpper lätt igen dessa.
          </v-card-text>
        </v-card>
        <v-card max-width="1000" class="ma-10" flat>
          <v-card-title class="justify-center">Tvätta peruken</v-card-title>
          <v-card-text>
            Precis som växande hår bör din peruk tvättas minst en gång i veckan. Detta kan göras i duschen med
            peruken på eller under kranen. Eftersom de flesta schampo är konstruerade för att ta bort fett från
            hårbotten (vilket torkar ut en peruk) rekommenderar vi att schampo och balsam för torrt, färgat
            eller permanentat hår används. Håret bör också behandlas med inpackning minst 1 gång per månad
            för att inte torka ut.
            Innan du blöter håret, red försiktigt ut eventuella tovor med en bredtandad kam. Börja i topparna
            och arbeta dig uppåt. Tvätta insidan av hättan som du gör varje dag. Använd ljummet vatten (aldrig
            varmt!) och håll peruken under kranen och låt vattnet rinna igenom håret i växtriktningen. När håret
            är genomblött applicerar du en liten mängd schampo (motsvarande en 5-krona i storlek). Fördela
            schampot med dina fingrar och pressa försiktigt för att arbeta upp ett lödder, gnugga inte! Skölj
            noga under rinnande vatten. Pressa ur överflödigt vatten ur håret (undvik att pressa hättan) med en
            torr handduk innan du applicerar balsam. Om håret är för blött kan det inte tillgodogöra sig balsam.
            Fördela balsam över håret med dina fingrar och krama försiktigt håret. Fördela därefter balsamet
            med en bredtandad kam och låt verka i 2-5 min (aldrig mer än 10 min). Skölj noga under ljummet,
            rinnande vatten. Var noga med att aldrig använda varmt vatten då detta kan skada silikonet i hättan.
            Torka genom att pressa håret i en handduk. Sätt på dig peruken och styla som vanligt eller låt den
            torka över natten på en perukstock.
            Skölj gärna håret innan du simmar i bassäng då blött hår inte suger upp lika mycket klor som torrt
            hår gör. Tvätta alltid håret samma dag du simmat i havet eller bassäng
          </v-card-text>
        </v-card>
        <v-card max-width="1000" class="ma-10" flat>
          <v-card-title class="justify-center">Hos frisören</v-card-title>
          <v-card-text>
            Välj gärna en lättskött frisyr som inte kräver fön eller varmluftsborste och tänk på att en tunn lugg
            täcker kanten i pannan på ett bra sätt. Undvik också frisyrer som är väldigt korta i nacken.
            Tänk på att håret inte växer ut om det klipps för kort, så ta det lugnt! Det är bättre att lämna det lite
            för långt och sedan komma tillbaka till frisören efter ett par veckor och klippa lite till.
            Det flesta som bär en Freedom Hair peruk vill helst att deras nya frisyr ska vara enkel att sköta och se
            så naturlig ut som möjligt. Detta kan åstadkommas på ett ganska enkelt sätt, men din frisör kanske
            uppskattar några tips. Att skära ut med rakblad underlättar ofta att få ett så naturligt utseende som
            möjligt och fungerar bra för att skapa en täckkant av småhår runt nacken, vid tinningarna och
            framför öronen. Hela håret bör dock inte tunnas med rakblad då detta kan leda till kluvna hårtoppar
            länge fram. Eftersom allt hår i peruken är lika långt behöver håret tunnas ut en del. En tunningssax
            är ett bra redskap för att få ett mer naturligt, aningen ojämnt utseende. Det är ofta bra att lämna
            håret en liten aning längre än du egentligen vill ha det. Tvätta och använd protesen i sju till tio dagar
            och återvänd sedan till salongen för en slutklippning. Kanthåret bör alltid vara kortare än det övriga
            håret, annars kommer håret runt kanten lyfta resten av håret bort från huden och kanten på hättan
            bli synlig. Var dock försiktig med att klippa kanthåret för kort framtill eftersom det då kan ställa sig
            rakt ut. Kanthåret bör inte vara kortare än till ögonbrynen och om resten av luggen lämnas lång, bör
            inga kanthår klippas precis runt benan. Lämna ett område på ca 2 cm på var sida om benan utan
            kanthår. Om du har långt hår, behövs kanthår klippas ut längs nackkanten för att dölja den när du
            sätter upp håret. Inte heller detta får klippas för kort utan bör vara minst 1 dm långt och tunnat för
            att ge ett flikigt utseende. Om du väljer en kortare frisyr, rekommenderar vi att den understa
            sektionen av håret i nacken (en 25 millimeter bred sektion längs kanten i nacken) bör vara minst
            10mm kortare än den slutliga längden i nacken. Nästa sektion bör också vara 10mm kortare än
            sektionen ovan. Målet är att skapa en page effekt, så att håret kommer så nära huden som möjlig.
            Om nacklinjen blir alltför tung kan spetsen på saxen användas för att tunna ut något.
            Vid permanent av en Freedom peruk är det viktigt att använda många spolar och plastpinnar för att
            lyfta spolarna ifrån skalpen för att undvika märken. Var noga med att inte lyfta håret vid hårfästet,
            utan låta håret ligga platt mot huden (över kanten på hättan) innan locken börjar. Om håret inte
            ligger mot huden kommer hårfästet att se mycket onaturligt ut. Placera alla spolar, utom de runt
            kanterna, i håret medan kunden har peruken på sig. Spolarna runt kanterna placeras när kunden
            tagit av sig peruken. Detta för att locken ska ligga in mot huden och inte utåt, vilket kommer att ske
            om spolarna placeras när kunden har peruken på sig.
          </v-card-text>
        </v-card>
        <v-card max-width="1000" class="ma-10" flat>
          <v-card-title class="justify-center">Styling och produkter</v-card-title>
          <v-card-text>
            Vi uppmuntrar dig att köpa kvalitetsprodukter som är avsedda för tonat eller permanentat hår från
            en salong. Det kan ta ett tag innan du hittar de produkter som passar dig och ditt hår bäst, precis
            som det skulle om du hade växande hår. Du bör göra en inpackning av ditt hår minst en gång per
            månad för att det inte ska torka ut, men lämna aldrig en inpackning i håret mer än 10 minuter då
            detta kan skada hättan. Använd gärna produkter med uv-filter när du vistas i solen för att undvika att
            håret bleks. Det går inte att helt undvika att håret bleks av solen och efter ett par månader brukar
            det vara på plats med en toning för att återfå hårets färg och lyster. Om du är blond och gärna vill att
            håret ska se slingat ut, kan det vara ett alternativ att lägga i lite mörkare slingor på toppen för att
            återfå skiftningarna i håret om det börjar se blekt ut.
            Kontrollera att din bredtandade kam eller rundborste inte har några skarpa kanter som kan skada
            hättan. Som del av din dagliga morgonrutin rekommenderar vi att du använder en sprejflaska med
            vatten för att fukta håret innan du kammar dig. Det här gör att stylingprodukter från gårdagen
            återaktiveras och frisyren får ett mjukare utseende. Håret tål både plattång och locktång, men var
            noga med att inte komma för nära hättan med tången och använd värmeskydd för att skydda håret
            från uttorkning.
          </v-card-text>
        </v-card>
        <v-card max-width="1000" class="ma-10" flat>
          <v-card-title class="justify-center">Freedom Wigs Ltd</v-card-title>
          <v-card-text>
            Freedom Wigs Ltd är beläget i Dunedin, Nya Zeeland och ägs och drivs av Deanna och Gary Beattie.
            Företaget grundades 1977 av Murray Barrington och drevs fram till 2015 av honom och hans fru
            Averill. Murray började med att tillverka herrtupéer hemma i källaren, men lusten att utveckla dessa
            vidare ledde så småningom till hårersättningar för kvinnor med alopecia totalis och universalis. Efter
            elva år hade Murray så tagit fram en peruk som både satt på plats utan tejp eller lim, var mycket
            naturtrogen och samtidigt bekväm. Efter ett omfattande forskningsarbete och produktutveckling
            lanserade Freedom Wigs 2008, sin fuktgenomsläppande silikonhätta, som både sitter där den ska
            och känns som en andra hud.
            Freedom Wigs utgörs av ett arbetslag på ca 40 personer, var och en specialist på sitt område i
            produktionskedjan så som tillverkning av hätta, bedömning av hårkvalité, blandning av hår,
            implantat eller reparationer. Alla är mycket kvalitetsmedvetna och engagerade i kundservice och
            produktutveckling.
            Freedom Hair har återförsäljare i ett flertal länder och de flesta av företagets
            återförsäljare har själva alopecia och har därför en unik erfarenhet av vad det innebär att använda
            peruk.
          </v-card-text>
        </v-card>
      </v-card>
    </v-layout>
  </v-content>
</template>

<script>
export default {
  name: "alopeci-peruk",
  components: {}
};
</script>

<style scoped>
#alopeci-peruk {
  font-family: "Montserrat";
}
</style>